<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px">
    <v-card>
      <v-card-title class="title">Total Summary</v-card-title>
      <v-card-text class="mt-3 body-2">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
            style="width:300px"
          >
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
              >
              <span>Total Entries:</span><span>{{selectedCOGS.length}}</span>
              </p>
              <!-- <p
                class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
              >
                <span>Total Amount in SGD:</span>
                <span>${{totalValues.totalAmts | thousandSeprator}}</span>
              </p> -->
              <span v-for="(item, index) in currencyTotals" :key="index">
                <p class="pa-0 ma-0 custom-font text-left d-flex justify-space-between" v-if="item && index === 'SGD'" >Total Amount in {{index}}: <span>{{utilsFunc.currencySym(index)}} {{item | thousandSeprator}}</span></p>
                <p class="pa-0 ma-0 custom-font text-left d-flex justify-space-between" v-if="item && index !== 'SGD'" >Inclusive ({{index}}): <span>{{utilsFunc.currencySym(index)}} {{item | thousandSeprator}}</span></p>
              </span>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex';
import config from '@/config';
import utils from '@/utils';
import Loading from 'vue-loading-overlay';
export default {
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    selectedCOGS: Array
  },
  data () {
    return {
      valid: true,
      isLoading: false,
      totalValues: {
        entries: 0,
        totalAmts: 0
      },
      currencyTotals: {},
      utilsFunc: utils.func
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      currencyRates: state => state.payment.currencyRates
    })
  },
  watch: {
    selectedCOGS: function (newSelectedCOGS) {
      this.totalValues = {
        entries: 0,
        totalAmts: 0
      }
      this.totalValues.entries = newSelectedCOGS.length
      newSelectedCOGS.map(ns => {
        this.totalValues.totalAmts += Number(ns.sgdGstIncluded) || Number(ns.amount)
      })
      this.detectCurrency(newSelectedCOGS)
      this.totalValues.totalAmts = (this.totalValues.totalAmts).toFixed(2)
    }
  },
  methods: {
    detectCurrency(items) {
      // detect different currency values and set to currency object
      let currencies = config.currencies
      currencies.map(c => {
        this.currencyTotals[c] = 0
      })
      items.map(item => {
        if (item.currency !== 'SGD') {
          this.currencyTotals['SGD'] += Number(utils.func.convertCurrency(item.currency, Number(item.GSTExcludedAmt) || Number(item.amount || 0), this.currencyRates))
          this.currencyTotals[item.currency] += Number(item.GSTExcludedAmt) || Number(item.amount || 0)
        } else {
          this.currencyTotals[item.currency] += Number(item.sgdGstIncluded) || Number(item.amount || 0)
        }
      })
      // Loop through the object and convert values toFixed(2)
      for (const currency in this.currencyTotals) {
        if (this.currencyTotals.hasOwnProperty(currency)) {
          if (this.currencyTotals[currency] > 0) {
            this.currencyTotals[currency] = this.currencyTotals[currency].toFixed(2);
          }
        }
      }
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// TotalSummaryModal.vue?4f13214d